import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axios from "axios";

let initialState = {
  isSubmitting: false,
  successMessage: null,
  error: null,
};

export const slice = createSlice({
  name: "kfInvoiceExport",
  initialState,
  reducers: {
    setSubmitting(state, action) {
      state.isSubmitting = action.payload;
    },
    setSuccess(state, action) {
      state.successMessage = action.payload;
      state.error = null;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.successMessage = null;
    },
  },
});

export const { setSubmitting, setSuccess, hasError } = slice.actions;

export default slice.reducer;

export function exportKFInvoiceByNumber(invoiceNumber) {
  const API_URL = process.env.REACT_APP_API_URL || '';
  return async () => {
    dispatch(slice.actions.setSubmitting(true));
    try {
      // First check if invoice is eligible for export (older than 45 days)
      const checkResponse = await axios.get(`${API_URL}/api/export/kashflow/invoice/${invoiceNumber}/check-eligibility`);

      if (!checkResponse.data.eligible) {
        throw new Error(checkResponse.data.message || "Invoice is not eligible for export (must be older than 45 days)");
      }

      // If eligible, download the invoice data
      const response = await axios.get(`${API_URL}/api/export/kashflow/invoice/${invoiceNumber}`, {
        responseType: 'blob',
      });

      // Create a Blob object from the response data
      const file = new Blob([response.data], { type: 'text/csv' });

      // Generate a URL for the Blob object
      const fileURL = URL.createObjectURL(file);

      // Create a temporary anchor element to enable file download
      const tempLink = document.createElement('a');
      tempLink.href = fileURL;
      tempLink.setAttribute('download', `KF_Invoice_${invoiceNumber}.csv`);
      tempLink.style.display = 'none';
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);

      // Revoke the Blob URL to free up resources
      URL.revokeObjectURL(fileURL);

      dispatch(slice.actions.setSuccess(`KF Invoice ${invoiceNumber} exported successfully`));
      return response;
    } catch (error) {
      console.error("KF Invoice export error", error);
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.setSubmitting(false));
    }
  };
}

